import {Component, EventEmitter, Output} from '@angular/core';


@Component({
  selector: 'app-botao-topo',
  standalone: true,
  imports: [],
  templateUrl: './botao-topo.component.html',
  styleUrl: './botao-topo.component.css'
})
export class BotaoTopoComponent {
  @Output() scrollToTop: EventEmitter<void> = new EventEmitter<void>();

  voltarAoTopo(): void {
    this.scrollToTop.emit();
  }
}
